import gql from 'graphql-tag';

export const resetPassword = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email) {
      status
    }
  }
`;

export const validateResetPassword = gql`
  mutation validateResetPassword($token: String!, $password: String!) {
    validateResetPassword(token: $token, password: $password) {
      status
    }
  }
`;
